import React from 'react';
import { EditContactContainer } from './edit-contacts';
import { Header } from '../../../header/header';
import { useMsal } from '@azure/msal-react';
import { HasRole, Role } from '../../../../utils/auth-utils';
import AccessDeniedPage from '../../../access-denied-page/access-denied-page';

export const EditContactPage = () => {
  const { accounts } = useMsal();
  const isAdmin = HasRole(accounts, Role.BookingAdmin);
  const isContactEditor = HasRole(accounts, Role.ContactEditor);

  if (!isAdmin && !isContactEditor) {
    return <AccessDeniedPage />;
  }

  return (
    <>
      <Header />
      <div className="edit-contact-page-container">
        <EditContactContainer />
      </div>
    </>
  );
};
